import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  constructor() {}

  static loadInitialState() {
    return Object.keys(sessionStorage).reduce((state: any, storageKey) => {
      if (storageKey.includes(environment.appPrefix)) {
        const stateKeys = storageKey
          .replace(environment.appPrefix, '')
          .toLowerCase()
          .split('.')
          .map(key =>
            key
              .split('-')
              .map((token, index) =>
                index === 0
                  ? token
                  : token.charAt(0).toUpperCase() + token.slice(1)
              )
              .join('')
          );
        let currentStateRef = state;
        stateKeys.forEach((key, index) => {
          if (index === stateKeys.length - 1) {
            currentStateRef[key] = JSON.parse(
              sessionStorage.getItem(storageKey)
            );
            return;
          }
          currentStateRef[key] = currentStateRef[key] || {};
          currentStateRef = currentStateRef[key];
        });
      }
      return state;
    }, {});
  }

  setItem(key: string, value: any) {
    sessionStorage.setItem(
      `${environment.appPrefix}${key}`,
      JSON.stringify(value)
    );
  }

  getItem(key: string, withPrefix = true) {
    if (!withPrefix) {
      return sessionStorage.getItem(key);
    }
    return JSON.parse(sessionStorage.getItem(`${environment.appPrefix}${key}`));
  }

  removeItem(key: string) {
    sessionStorage.removeItem(`${environment.appPrefix}${key}`);
  }

  /** Tests that sessionStorage exists, can be written to, and read from. */
  testsessionStorage() {
    const testValue = 'testValue';
    const testKey = 'testKey';
    let retrievedValue: string;
    const errorMessage = 'sessionStorage did not return expected value';

    this.setItem(testKey, testValue);
    retrievedValue = this.getItem(testKey);
    this.removeItem(testKey);

    if (retrievedValue !== testValue) {
      throw new Error(errorMessage);
    }
  }
}
